"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_transition_group_1 = require("react-transition-group");
var ui_components_1 = require("@l2p/ui-components");
var SearchGamesDropdown_1 = __importDefault(require("../../SearchGamesDropdown"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var common_hooks_1 = require("@l2p/common-hooks/");
var ui_components_2 = require("@l2p/ui-components");
var durationTransition = 500;
var defaultStyle = {
    transition: "all ".concat(durationTransition, "ms ease-in-out"),
    opacity: 0,
    overflow: 'hidden',
    maxHeight: 0,
};
var transitionStyles = {
    entering: { opacity: 1, maxHeight: '100%' },
    entered: { opacity: 1, maxHeight: '100%' },
    exiting: { opacity: 0, maxHeight: 0 },
    exited: { opacity: 0, maxHeight: 0 },
};
var SearchByValue = function (_a) {
    var gameCardPlaceholder = _a.gameCardPlaceholder, _b = _a.isShowPlaceholder, isShowPlaceholder = _b === void 0 ? true : _b;
    var _c = (0, common_hooks_1.useSearchByValue)(), isSubmitting = _c.isSubmitting, games = _c.games, searchValue = _c.searchValue, isSearchActive = _c.isSearchActive, handleSearchInputChange = _c.handleSearchInputChange, handleSearchInputClear = _c.handleSearchInputClear;
    return (react_1.default.createElement(react_transition_group_1.Transition, { in: true, timeout: durationTransition }, function (state) { return (react_1.default.createElement("div", { style: __assign(__assign({}, defaultStyle), transitionStyles[state]) },
        react_1.default.createElement("div", null,
            react_1.default.createElement(react_transition_group_1.Transition, { in: isSearchActive, timeout: durationTransition }, function (state) { return (react_1.default.createElement("div", { style: __assign(__assign({}, defaultStyle), transitionStyles[state]) },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.searchFieldsWrapper },
                    react_1.default.createElement(ui_components_1.SearchInput, { value: searchValue, onClear: handleSearchInputClear, onChange: handleSearchInputChange })))); })),
        isSubmitting ? (react_1.default.createElement(ui_components_2.LoadingWithContainer, null)) : (react_1.default.createElement(react_1.default.Fragment, null, isSearchActive
            ? (isShowPlaceholder || games.length) && (react_1.default.createElement(SearchGamesDropdown_1.default, { searchValue: searchValue, games: games, gameCardPlaceholder: gameCardPlaceholder }))
            : null)))); }));
};
exports.default = SearchByValue;
